/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetOrdiniFilter,
  OrdineCreateDTO,
  OrdineDTO,
  OrdineDettaglioCreateDTO,
  OrdineDettaglioDTO,
  OrdineDettaglioUpdateDTO,
  OrdinePosDTO,
  OrdineUpdateDTO,
  ProblemDetails,
  ProdottoDTO,
} from '../models/index';
import {
    GetOrdiniFilterFromJSON,
    GetOrdiniFilterToJSON,
    OrdineCreateDTOFromJSON,
    OrdineCreateDTOToJSON,
    OrdineDTOFromJSON,
    OrdineDTOToJSON,
    OrdineDettaglioCreateDTOFromJSON,
    OrdineDettaglioCreateDTOToJSON,
    OrdineDettaglioDTOFromJSON,
    OrdineDettaglioDTOToJSON,
    OrdineDettaglioUpdateDTOFromJSON,
    OrdineDettaglioUpdateDTOToJSON,
    OrdinePosDTOFromJSON,
    OrdinePosDTOToJSON,
    OrdineUpdateDTOFromJSON,
    OrdineUpdateDTOToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ProdottoDTOFromJSON,
    ProdottoDTOToJSON,
} from '../models/index';

export interface CloseOrdineRequest {
    idOrdine: number;
}

export interface DeleteOrdineRequest {
    idOrdine: number;
}

export interface DeleteOrdineDettaglioRequest {
    idOrdine: number;
    idDettaglio: number;
}

export interface GetOrdineByIdRequest {
    idOrdine: number;
}

export interface GetOrdineDettaglioByIdRequest {
    idOrdine: number;
    idDettaglio: number;
}

export interface GetOrdinePosRequest {
    idOrdine: number;
}

export interface GetOrdineReportRequest {
    idOrdine: number;
}

export interface GetOrdineReportSignedRequest {
    idOrdine: number;
}

export interface GetOrdiniRequest {
    filter?: GetOrdiniFilter;
}

export interface GetOrdiniDettagliRequest {
    idOrdine: number;
}

export interface GetProdottiByOrdineRequest {
    idOrdine: number;
}

export interface GetProdottoByOrdineAndIdRequest {
    idOrdine: number;
    idProdotto: string;
}

export interface InsertOrdineRequest {
    ordineCreateDTO?: OrdineCreateDTO;
}

export interface InsertOrdineDettaglioRequest {
    idOrdine: number;
    ordineDettaglioCreateDTO?: OrdineDettaglioCreateDTO;
}

export interface OpenOrdineRequest {
    idOrdine: number;
}

export interface SetOrdineReportSignRequest {
    idOrdine: number;
    sign?: Blob;
}

export interface UpdateOrdineRequest {
    idOrdine: number;
    ordineUpdateDTO?: OrdineUpdateDTO;
}

export interface UpdateOrdineDettaglioRequest {
    idOrdine: number;
    idDettaglio: number;
    ordineDettaglioUpdateDTO?: OrdineDettaglioUpdateDTO;
}

/**
 * 
 */
export class OrdiniApi extends runtime.BaseAPI {

    /**
     * Chiude un ordine
     */
    async closeOrdineRaw(requestParameters: CloseOrdineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['idOrdine'] == null) {
            throw new runtime.RequiredError(
                'idOrdine',
                'Required parameter "idOrdine" was null or undefined when calling closeOrdine().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Ordini/{idOrdine}/Close`.replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Chiude un ordine
     */
    async closeOrdine(requestParameters: CloseOrdineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.closeOrdineRaw(requestParameters, initOverrides);
    }

    /**
     * Elimina un ordine esistente
     */
    async deleteOrdineRaw(requestParameters: DeleteOrdineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['idOrdine'] == null) {
            throw new runtime.RequiredError(
                'idOrdine',
                'Required parameter "idOrdine" was null or undefined when calling deleteOrdine().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Ordini/{idOrdine}`.replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Elimina un ordine esistente
     */
    async deleteOrdine(requestParameters: DeleteOrdineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteOrdineRaw(requestParameters, initOverrides);
    }

    /**
     * Elimina un dettaglio dell\'ordine
     */
    async deleteOrdineDettaglioRaw(requestParameters: DeleteOrdineDettaglioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['idOrdine'] == null) {
            throw new runtime.RequiredError(
                'idOrdine',
                'Required parameter "idOrdine" was null or undefined when calling deleteOrdineDettaglio().'
            );
        }

        if (requestParameters['idDettaglio'] == null) {
            throw new runtime.RequiredError(
                'idDettaglio',
                'Required parameter "idDettaglio" was null or undefined when calling deleteOrdineDettaglio().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Ordini/{idOrdine}/Dettagli/{idDettaglio}`.replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))).replace(`{${"idDettaglio"}}`, encodeURIComponent(String(requestParameters['idDettaglio']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Elimina un dettaglio dell\'ordine
     */
    async deleteOrdineDettaglio(requestParameters: DeleteOrdineDettaglioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteOrdineDettaglioRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getOrdineByIdRaw(requestParameters: GetOrdineByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrdineDTO>> {
        if (requestParameters['idOrdine'] == null) {
            throw new runtime.RequiredError(
                'idOrdine',
                'Required parameter "idOrdine" was null or undefined when calling getOrdineById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Ordini/{idOrdine}`.replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrdineDTOFromJSON(jsonValue));
    }

    /**
     */
    async getOrdineById(requestParameters: GetOrdineByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrdineDTO> {
        const response = await this.getOrdineByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Recupera un dettaglio dell\'ordine per id
     */
    async getOrdineDettaglioByIdRaw(requestParameters: GetOrdineDettaglioByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrdineDettaglioDTO>> {
        if (requestParameters['idOrdine'] == null) {
            throw new runtime.RequiredError(
                'idOrdine',
                'Required parameter "idOrdine" was null or undefined when calling getOrdineDettaglioById().'
            );
        }

        if (requestParameters['idDettaglio'] == null) {
            throw new runtime.RequiredError(
                'idDettaglio',
                'Required parameter "idDettaglio" was null or undefined when calling getOrdineDettaglioById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Ordini/{idOrdine}/Dettagli/{idDettaglio}`.replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))).replace(`{${"idDettaglio"}}`, encodeURIComponent(String(requestParameters['idDettaglio']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrdineDettaglioDTOFromJSON(jsonValue));
    }

    /**
     * Recupera un dettaglio dell\'ordine per id
     */
    async getOrdineDettaglioById(requestParameters: GetOrdineDettaglioByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrdineDettaglioDTO> {
        const response = await this.getOrdineDettaglioByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrdinePosRaw(requestParameters: GetOrdinePosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrdinePosDTO>>> {
        if (requestParameters['idOrdine'] == null) {
            throw new runtime.RequiredError(
                'idOrdine',
                'Required parameter "idOrdine" was null or undefined when calling getOrdinePos().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Ordini/{idOrdine}/Pos`.replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrdinePosDTOFromJSON));
    }

    /**
     */
    async getOrdinePos(requestParameters: GetOrdinePosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrdinePosDTO>> {
        const response = await this.getOrdinePosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrdineReportRaw(requestParameters: GetOrdineReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['idOrdine'] == null) {
            throw new runtime.RequiredError(
                'idOrdine',
                'Required parameter "idOrdine" was null or undefined when calling getOrdineReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Ordini/{idOrdine}/Report`.replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async getOrdineReport(requestParameters: GetOrdineReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getOrdineReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrdineReportSignedRaw(requestParameters: GetOrdineReportSignedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['idOrdine'] == null) {
            throw new runtime.RequiredError(
                'idOrdine',
                'Required parameter "idOrdine" was null or undefined when calling getOrdineReportSigned().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Ordini/{idOrdine}/Report/Sign`.replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async getOrdineReportSigned(requestParameters: GetOrdineReportSignedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getOrdineReportSignedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrdiniRaw(requestParameters: GetOrdiniRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrdineDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Ordini`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrdineDTOFromJSON));
    }

    /**
     */
    async getOrdini(requestParameters: GetOrdiniRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrdineDTO>> {
        const response = await this.getOrdiniRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrdiniDettagliRaw(requestParameters: GetOrdiniDettagliRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrdineDettaglioDTO>>> {
        if (requestParameters['idOrdine'] == null) {
            throw new runtime.RequiredError(
                'idOrdine',
                'Required parameter "idOrdine" was null or undefined when calling getOrdiniDettagli().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Ordini/{idOrdine}/Dettagli`.replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrdineDettaglioDTOFromJSON));
    }

    /**
     */
    async getOrdiniDettagli(requestParameters: GetOrdiniDettagliRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrdineDettaglioDTO>> {
        const response = await this.getOrdiniDettagliRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getProdottiByOrdineRaw(requestParameters: GetProdottiByOrdineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProdottoDTO>>> {
        if (requestParameters['idOrdine'] == null) {
            throw new runtime.RequiredError(
                'idOrdine',
                'Required parameter "idOrdine" was null or undefined when calling getProdottiByOrdine().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Ordini/{idOrdine}/Prodotti`.replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProdottoDTOFromJSON));
    }

    /**
     */
    async getProdottiByOrdine(requestParameters: GetProdottiByOrdineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProdottoDTO>> {
        const response = await this.getProdottiByOrdineRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getProdottoByOrdineAndIdRaw(requestParameters: GetProdottoByOrdineAndIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProdottoDTO>> {
        if (requestParameters['idOrdine'] == null) {
            throw new runtime.RequiredError(
                'idOrdine',
                'Required parameter "idOrdine" was null or undefined when calling getProdottoByOrdineAndId().'
            );
        }

        if (requestParameters['idProdotto'] == null) {
            throw new runtime.RequiredError(
                'idProdotto',
                'Required parameter "idProdotto" was null or undefined when calling getProdottoByOrdineAndId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Ordini/{idOrdine}/Prodotti/{idProdotto}`.replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))).replace(`{${"idProdotto"}}`, encodeURIComponent(String(requestParameters['idProdotto']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProdottoDTOFromJSON(jsonValue));
    }

    /**
     */
    async getProdottoByOrdineAndId(requestParameters: GetProdottoByOrdineAndIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProdottoDTO> {
        const response = await this.getProdottoByOrdineAndIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Crea un nuovo ordine
     */
    async insertOrdineRaw(requestParameters: InsertOrdineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrdineDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Ordini`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrdineCreateDTOToJSON(requestParameters['ordineCreateDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrdineDTOFromJSON(jsonValue));
    }

    /**
     * Crea un nuovo ordine
     */
    async insertOrdine(requestParameters: InsertOrdineRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrdineDTO> {
        const response = await this.insertOrdineRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Crea un nuovo dettaglio dell\'ordine
     */
    async insertOrdineDettaglioRaw(requestParameters: InsertOrdineDettaglioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrdineDettaglioDTO>> {
        if (requestParameters['idOrdine'] == null) {
            throw new runtime.RequiredError(
                'idOrdine',
                'Required parameter "idOrdine" was null or undefined when calling insertOrdineDettaglio().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Ordini/{idOrdine}/Dettagli`.replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrdineDettaglioCreateDTOToJSON(requestParameters['ordineDettaglioCreateDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrdineDettaglioDTOFromJSON(jsonValue));
    }

    /**
     * Crea un nuovo dettaglio dell\'ordine
     */
    async insertOrdineDettaglio(requestParameters: InsertOrdineDettaglioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrdineDettaglioDTO> {
        const response = await this.insertOrdineDettaglioRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Riapre un ordine
     */
    async openOrdineRaw(requestParameters: OpenOrdineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['idOrdine'] == null) {
            throw new runtime.RequiredError(
                'idOrdine',
                'Required parameter "idOrdine" was null or undefined when calling openOrdine().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Ordini/{idOrdine}/Open`.replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Riapre un ordine
     */
    async openOrdine(requestParameters: OpenOrdineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.openOrdineRaw(requestParameters, initOverrides);
    }

    /**
     */
    async setOrdineReportSignRaw(requestParameters: SetOrdineReportSignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['idOrdine'] == null) {
            throw new runtime.RequiredError(
                'idOrdine',
                'Required parameter "idOrdine" was null or undefined when calling setOrdineReportSign().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['sign'] != null) {
            formParams.append('sign', requestParameters['sign'] as any);
        }

        const response = await this.request({
            path: `/Ordini/{idOrdine}/Report/Sign`.replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async setOrdineReportSign(requestParameters: SetOrdineReportSignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.setOrdineReportSignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Aggiorna un ordine esistente
     */
    async updateOrdineRaw(requestParameters: UpdateOrdineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['idOrdine'] == null) {
            throw new runtime.RequiredError(
                'idOrdine',
                'Required parameter "idOrdine" was null or undefined when calling updateOrdine().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Ordini/{idOrdine}`.replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrdineUpdateDTOToJSON(requestParameters['ordineUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Aggiorna un ordine esistente
     */
    async updateOrdine(requestParameters: UpdateOrdineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateOrdineRaw(requestParameters, initOverrides);
    }

    /**
     * Aggiorna un dettaglio esistente
     */
    async updateOrdineDettaglioRaw(requestParameters: UpdateOrdineDettaglioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['idOrdine'] == null) {
            throw new runtime.RequiredError(
                'idOrdine',
                'Required parameter "idOrdine" was null or undefined when calling updateOrdineDettaglio().'
            );
        }

        if (requestParameters['idDettaglio'] == null) {
            throw new runtime.RequiredError(
                'idDettaglio',
                'Required parameter "idDettaglio" was null or undefined when calling updateOrdineDettaglio().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Ordini/{idOrdine}/Dettagli/{idDettaglio}`.replace(`{${"idOrdine"}}`, encodeURIComponent(String(requestParameters['idOrdine']))).replace(`{${"idDettaglio"}}`, encodeURIComponent(String(requestParameters['idDettaglio']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrdineDettaglioUpdateDTOToJSON(requestParameters['ordineDettaglioUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Aggiorna un dettaglio esistente
     */
    async updateOrdineDettaglio(requestParameters: UpdateOrdineDettaglioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateOrdineDettaglioRaw(requestParameters, initOverrides);
    }

}
